// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://idctavngatyyileoitgz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlkY3Rhdm5nYXR5eWlsZW9pdGd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzOTUyMTYsImV4cCI6MjA2Mzk3MTIxNn0.RJVZcUzCn03Jp4K1eIuP2kjT5zV-1sFnDfoZNvB7UK0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // Necessário para processar OAuth callbacks (Azure, etc)
  }
});